/* eslint-disable react/no-array-index-key */
import {css} from '@mui/material';
import * as React from 'react';

import {HaidiAtbSusceptibilityListFormatter} from './HaidiAtbSusceptibilityFormatter';
import {HaidiHaiStateFormatter} from './HaidiHaiStateFormatter';
import {AG_GRID_COMPATIBILITY} from '../LightTable';
import {HaidiSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';

type Props = TemplatedCellRendererParams<HaidiSchema.components['schemas']['PatientEventDto']> & {
  snomedLabels: Record<string, string>;
  snomedLabelsLoading: boolean;
};

const muiStyles = {
  wrapper: css`
    position: relative;
    height: 100%;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    text-align: left;
  `,
  atbChip: css`
    max-width: 100%;
    border-radius: 4px;
    padding: 3px 0;
    display: inline-flex;
    justify-content: flex-start;
    align-items: flex-start;
  `,
};

export const HealthcareTableDetailFormatter: React.FC<Props> = (props) => {
  const {data, snomedLabels, snomedLabelsLoading} = props;

  let haiState: string | undefined;
  switch (data.eventType) {
    case 'REPORTED_HAI':
      haiState = 'REP';
      break;
    case 'CONFIRMED_HAI':
      haiState = 'YES';
      break;
    case 'COLONIZATION_HAI':
      haiState = 'COL';
      break;
    case 'WORK_IN_PROGRESS_HAI':
      haiState = 'WIP';
      break;
  }

  let detail: JSX.Element | undefined;
  switch (data.eventType) {
    case 'HOSPITALIZATION_START':
      break;
    case 'TRANSFER':
      break;
    case 'HOSPITALIZATION_END':
      break;
    case 'LABORATORY':
      detail = (
        <HaidiAtbSusceptibilityListFormatter
          value={data.atbSusceptibilities ?? []}
          snomedLabels={snomedLabels}
          snomedLabelsLoading={snomedLabelsLoading}
        />
      );
      break;
    case 'OUTPATIENT':
      break;
    case 'REPORTED_HAI':
    case 'CONFIRMED_HAI':
    case 'COLONIZATION_HAI':
    case 'WORK_IN_PROGRESS_HAI':
      detail = <HaidiHaiStateFormatter {...AG_GRID_COMPATIBILITY} data={{state: haiState}} value={haiState} />;
      break;
  }

  return <span css={muiStyles.wrapper}>{detail}</span>;
};
HealthcareTableDetailFormatter.displayName = 'HealthcareTableDetailFormatter';
